module.exports = __webpack_public_path__ + "mainassets/img/inno_main.f280dcd7.jpg";